// GENERATED by `npm run countries` from web-app/shared/countries.json.
// Do not edit. Edit the JSON and regenerate.
//
// Sorted longest dial code first, then by priority: the order is the lookup
// used to parse an E.164 string back into a country. See gen-countries.ts.

/** One country's dialling data. `format` uses `.` as a digit placeholder. */
export interface Country {
  /** English name, as shown in the picker. */
  name: string;
  /** Lower-case ISO 3166-1 alpha-2. The stable key; never shown raw. */
  iso2: string;
  /** Digits only, no plus. */
  dial: string;
  /** National grouping mask, absent where the country has no settled one. */
  format?: string;
  /** Tie-break where a dial code is shared. Lower wins. */
  priority?: number;
  /** NANP prefixes that pick this country out of the ones sharing its dial code. */
  areaCodes?: readonly string[];
}

export const COUNTRIES: readonly Country[] = [
  { name: "Antigua and Barbuda", iso2: "ag", dial: "1268" },
  { name: "Bahamas", iso2: "bs", dial: "1242" },
  { name: "Barbados", iso2: "bb", dial: "1246" },
  { name: "Dominica", iso2: "dm", dial: "1767" },
  { name: "Grenada", iso2: "gd", dial: "1473" },
  { name: "Guam", iso2: "gu", dial: "1671" },
  { name: "Jamaica", iso2: "jm", dial: "1876" },
  { name: "Saint Kitts and Nevis", iso2: "kn", dial: "1869" },
  { name: "Saint Lucia", iso2: "lc", dial: "1758" },
  { name: "Saint Vincent and the Grenadines", iso2: "vc", dial: "1784" },
  { name: "Trinidad and Tobago", iso2: "tt", dial: "1868" },
  { name: "Curaçao", iso2: "cw", dial: "599", priority: 0 },
  { name: "Guadeloupe", iso2: "gp", dial: "590", format: "... .. .. ..", priority: 0 },
  { name: "Réunion", iso2: "re", dial: "262", format: "... .. .. ..", priority: 0 },
  { name: "Caribbean Netherlands", iso2: "bq", dial: "599", priority: 1 },
  {
    name: "Mayotte",
    iso2: "yt",
    dial: "262",
    format: "... .. .. ..",
    priority: 1,
    areaCodes: ["269", "639"],
  },
  { name: "Albania", iso2: "al", dial: "355" },
  { name: "Algeria", iso2: "dz", dial: "213" },
  { name: "Andorra", iso2: "ad", dial: "376" },
  { name: "Angola", iso2: "ao", dial: "244" },
  { name: "Armenia", iso2: "am", dial: "374", format: ".. ......" },
  { name: "Aruba", iso2: "aw", dial: "297" },
  { name: "Azerbaijan", iso2: "az", dial: "994", format: "(..) ... .. .." },
  { name: "Bahrain", iso2: "bh", dial: "973", format: ".... ...." },
  { name: "Bangladesh", iso2: "bd", dial: "880" },
  { name: "Belarus", iso2: "by", dial: "375", format: "(..) ... .. .." },
  { name: "Belize", iso2: "bz", dial: "501" },
  { name: "Benin", iso2: "bj", dial: "229" },
  { name: "Bhutan", iso2: "bt", dial: "975" },
  { name: "Bolivia", iso2: "bo", dial: "591" },
  { name: "Bosnia and Herzegovina", iso2: "ba", dial: "387" },
  { name: "Botswana", iso2: "bw", dial: "267" },
  { name: "British Indian Ocean Territory", iso2: "io", dial: "246" },
  { name: "Brunei", iso2: "bn", dial: "673" },
  { name: "Bulgaria", iso2: "bg", dial: "359" },
  { name: "Burkina Faso", iso2: "bf", dial: "226" },
  { name: "Burundi", iso2: "bi", dial: "257" },
  { name: "Cambodia", iso2: "kh", dial: "855" },
  { name: "Cameroon", iso2: "cm", dial: "237" },
  { name: "Cape Verde", iso2: "cv", dial: "238" },
  { name: "Central African Republic", iso2: "cf", dial: "236" },
  { name: "Chad", iso2: "td", dial: "235" },
  { name: "Comoros", iso2: "km", dial: "269" },
  { name: "Congo", iso2: "cd", dial: "243" },
  { name: "Congo", iso2: "cg", dial: "242" },
  { name: "Costa Rica", iso2: "cr", dial: "506", format: "....-...." },
  { name: "Côte d'Ivoire", iso2: "ci", dial: "225", format: ".. .. .. .. .." },
  { name: "Croatia", iso2: "hr", dial: "385" },
  { name: "Cyprus", iso2: "cy", dial: "357", format: ".. ......" },
  { name: "Czech Republic", iso2: "cz", dial: "420", format: "... ... ..." },
  { name: "Djibouti", iso2: "dj", dial: "253", format: ".. .. ...." },
  { name: "Ecuador", iso2: "ec", dial: "593" },
  { name: "El Salvador", iso2: "sv", dial: "503", format: "....-...." },
  { name: "Equatorial Guinea", iso2: "gq", dial: "240" },
  { name: "Eritrea", iso2: "er", dial: "291" },
  { name: "Estonia", iso2: "ee", dial: "372", format: ".... ......" },
  { name: "Ethiopia", iso2: "et", dial: "251", format: ".. ... ...." },
  { name: "Faroe Islands", iso2: "fo", dial: "298", format: ".. .. .." },
  { name: "Fiji", iso2: "fj", dial: "679" },
  { name: "Finland", iso2: "fi", dial: "358", format: ".. ... .. .." },
  { name: "French Guiana", iso2: "gf", dial: "594", format: "... .. .. .." },
  { name: "French Polynesia", iso2: "pf", dial: "689" },
  { name: "Gabon", iso2: "ga", dial: "241" },
  { name: "Gambia", iso2: "gm", dial: "220" },
  { name: "Georgia", iso2: "ge", dial: "995" },
  { name: "Ghana", iso2: "gh", dial: "233" },
  { name: "Gibraltar", iso2: "gi", dial: "350" },
  { name: "Greenland", iso2: "gl", dial: "299", format: ".. .. .." },
  { name: "Guatemala", iso2: "gt", dial: "502", format: "....-...." },
  { name: "Guinea", iso2: "gn", dial: "224" },
  { name: "Guinea-Bissau", iso2: "gw", dial: "245" },
  { name: "Guyana", iso2: "gy", dial: "592" },
  { name: "Haiti", iso2: "ht", dial: "509", format: "....-...." },
  { name: "Honduras", iso2: "hn", dial: "504" },
  { name: "Hong Kong", iso2: "hk", dial: "852", format: ".... ...." },
  { name: "Iceland", iso2: "is", dial: "354", format: "... ...." },
  { name: "Iraq", iso2: "iq", dial: "964" },
  { name: "Ireland", iso2: "ie", dial: "353", format: ".. ......." },
  { name: "Israel", iso2: "il", dial: "972", format: "... ... ...." },
  { name: "Jordan", iso2: "jo", dial: "962" },
  { name: "Kenya", iso2: "ke", dial: "254" },
  { name: "Kiribati", iso2: "ki", dial: "686" },
  { name: "Kosovo", iso2: "xk", dial: "383" },
  { name: "Kuwait", iso2: "kw", dial: "965", format: ".... ...." },
  { name: "Kyrgyzstan", iso2: "kg", dial: "996", format: "... ... ..." },
  { name: "Laos", iso2: "la", dial: "856" },
  { name: "Latvia", iso2: "lv", dial: "371", format: ".. ... ..." },
  { name: "Lebanon", iso2: "lb", dial: "961" },
  { name: "Lesotho", iso2: "ls", dial: "266" },
  { name: "Liberia", iso2: "lr", dial: "231" },
  { name: "Libya", iso2: "ly", dial: "218" },
  { name: "Liechtenstein", iso2: "li", dial: "423" },
  { name: "Lithuania", iso2: "lt", dial: "370" },
  { name: "Luxembourg", iso2: "lu", dial: "352" },
  { name: "Macau", iso2: "mo", dial: "853" },
  { name: "Macedonia", iso2: "mk", dial: "389" },
  { name: "Madagascar", iso2: "mg", dial: "261" },
  { name: "Malawi", iso2: "mw", dial: "265" },
  { name: "Maldives", iso2: "mv", dial: "960" },
  { name: "Mali", iso2: "ml", dial: "223" },
  { name: "Malta", iso2: "mt", dial: "356" },
  { name: "Marshall Islands", iso2: "mh", dial: "692" },
  { name: "Martinique", iso2: "mq", dial: "596", format: "... .. .. .." },
  { name: "Mauritania", iso2: "mr", dial: "222" },
  { name: "Mauritius", iso2: "mu", dial: "230" },
  { name: "Micronesia", iso2: "fm", dial: "691" },
  { name: "Moldova", iso2: "md", dial: "373", format: "(..) ..-..-.." },
  { name: "Monaco", iso2: "mc", dial: "377" },
  { name: "Mongolia", iso2: "mn", dial: "976" },
  { name: "Montenegro", iso2: "me", dial: "382" },
  { name: "Morocco", iso2: "ma", dial: "212" },
  { name: "Mozambique", iso2: "mz", dial: "258" },
  { name: "Namibia", iso2: "na", dial: "264" },
  { name: "Nauru", iso2: "nr", dial: "674" },
  { name: "Nepal", iso2: "np", dial: "977" },
  { name: "New Caledonia", iso2: "nc", dial: "687" },
  { name: "Nicaragua", iso2: "ni", dial: "505" },
  { name: "Niger", iso2: "ne", dial: "227" },
  { name: "Nigeria", iso2: "ng", dial: "234" },
  { name: "North Korea", iso2: "kp", dial: "850" },
  { name: "Oman", iso2: "om", dial: "968", format: ".... ...." },
  { name: "Palau", iso2: "pw", dial: "680" },
  { name: "Palestine", iso2: "ps", dial: "970" },
  { name: "Panama", iso2: "pa", dial: "507" },
  { name: "Papua New Guinea", iso2: "pg", dial: "675" },
  { name: "Paraguay", iso2: "py", dial: "595" },
  { name: "Portugal", iso2: "pt", dial: "351" },
  { name: "Qatar", iso2: "qa", dial: "974", format: ".... ...." },
  { name: "Rwanda", iso2: "rw", dial: "250" },
  { name: "Saint Pierre & Miquelon", iso2: "pm", dial: "508" },
  { name: "Samoa", iso2: "ws", dial: "685" },
  { name: "San Marino", iso2: "sm", dial: "378" },
  { name: "São Tomé and Príncipe", iso2: "st", dial: "239" },
  { name: "Saudi Arabia", iso2: "sa", dial: "966", format: ".. ... ...." },
  { name: "Senegal", iso2: "sn", dial: "221" },
  { name: "Serbia", iso2: "rs", dial: "381" },
  { name: "Seychelles", iso2: "sc", dial: "248" },
  { name: "Sierra Leone", iso2: "sl", dial: "232" },
  { name: "Slovakia", iso2: "sk", dial: "421" },
  { name: "Slovenia", iso2: "si", dial: "386" },
  { name: "Solomon Islands", iso2: "sb", dial: "677" },
  { name: "Somalia", iso2: "so", dial: "252" },
  { name: "South Sudan", iso2: "ss", dial: "211" },
  { name: "Sudan", iso2: "sd", dial: "249" },
  { name: "Suriname", iso2: "sr", dial: "597" },
  { name: "Swaziland", iso2: "sz", dial: "268" },
  { name: "Syria", iso2: "sy", dial: "963" },
  { name: "Taiwan", iso2: "tw", dial: "886" },
  { name: "Tajikistan", iso2: "tj", dial: "992" },
  { name: "Tanzania", iso2: "tz", dial: "255" },
  { name: "Timor-Leste", iso2: "tl", dial: "670" },
  { name: "Togo", iso2: "tg", dial: "228" },
  { name: "Tonga", iso2: "to", dial: "676" },
  { name: "Tunisia", iso2: "tn", dial: "216" },
  { name: "Turkmenistan", iso2: "tm", dial: "993" },
  { name: "Tuvalu", iso2: "tv", dial: "688" },
  { name: "Uganda", iso2: "ug", dial: "256" },
  { name: "Ukraine", iso2: "ua", dial: "380", format: "(..) ... .. .." },
  { name: "United Arab Emirates", iso2: "ae", dial: "971" },
  { name: "Uruguay", iso2: "uy", dial: "598" },
  { name: "Uzbekistan", iso2: "uz", dial: "998", format: ".. ... .. .." },
  { name: "Vanuatu", iso2: "vu", dial: "678" },
  { name: "Wallis & Futuna", iso2: "wf", dial: "681", format: ".. .. .." },
  { name: "Yemen", iso2: "ye", dial: "967" },
  { name: "Zambia", iso2: "zm", dial: "260" },
  { name: "Zimbabwe", iso2: "zw", dial: "263" },
  { name: "Argentina", iso2: "ar", dial: "54", priority: 0 },
  { name: "Australia", iso2: "au", dial: "61", priority: 0 },
  { name: "Italy", iso2: "it", dial: "39", format: "... .......", priority: 0 },
  { name: "Mexico", iso2: "mx", dial: "52", format: "... ... ....", priority: 0 },
  { name: "Vatican City", iso2: "va", dial: "39", format: ".. .... ....", priority: 1 },
  { name: "Afghanistan", iso2: "af", dial: "93" },
  { name: "Austria", iso2: "at", dial: "43" },
  { name: "Belgium", iso2: "be", dial: "32", format: "... .. .. .." },
  { name: "Brazil", iso2: "br", dial: "55", format: "(..) .....-...." },
  { name: "Chile", iso2: "cl", dial: "56" },
  { name: "China", iso2: "cn", dial: "86", format: "... .... ...." },
  { name: "Colombia", iso2: "co", dial: "57", format: "... ... ...." },
  { name: "Cuba", iso2: "cu", dial: "53" },
  { name: "Denmark", iso2: "dk", dial: "45", format: ".. .. .. .." },
  { name: "Egypt", iso2: "eg", dial: "20" },
  { name: "France", iso2: "fr", dial: "33", format: ". .. .. .. .." },
  { name: "Germany", iso2: "de", dial: "49", format: "... ........." },
  { name: "Greece", iso2: "gr", dial: "30" },
  { name: "Hungary", iso2: "hu", dial: "36" },
  { name: "India", iso2: "in", dial: "91", format: ".....-....." },
  { name: "Indonesia", iso2: "id", dial: "62" },
  { name: "Iran", iso2: "ir", dial: "98", format: "... ... ...." },
  { name: "Japan", iso2: "jp", dial: "81", format: ".. .... ...." },
  { name: "Malaysia", iso2: "my", dial: "60", format: "..-....-...." },
  { name: "Myanmar", iso2: "mm", dial: "95" },
  { name: "Netherlands", iso2: "nl", dial: "31" },
  { name: "New Zealand", iso2: "nz", dial: "64", format: "...-...-...." },
  { name: "Norway", iso2: "no", dial: "47", format: "... .. ..." },
  { name: "Pakistan", iso2: "pk", dial: "92", format: "...-......." },
  { name: "Peru", iso2: "pe", dial: "51" },
  { name: "Philippines", iso2: "ph", dial: "63", format: "... ... ...." },
  { name: "Poland", iso2: "pl", dial: "48", format: "...-...-..." },
  { name: "Romania", iso2: "ro", dial: "40" },
  { name: "Singapore", iso2: "sg", dial: "65", format: "....-...." },
  { name: "South Africa", iso2: "za", dial: "27" },
  { name: "South Korea", iso2: "kr", dial: "82", format: "... .... ...." },
  { name: "Spain", iso2: "es", dial: "34", format: "... ... ..." },
  { name: "Sri Lanka", iso2: "lk", dial: "94" },
  { name: "Sweden", iso2: "se", dial: "46", format: "... ... ..." },
  { name: "Switzerland", iso2: "ch", dial: "41", format: ".. ... .. .." },
  { name: "Thailand", iso2: "th", dial: "66" },
  { name: "Turkey", iso2: "tr", dial: "90", format: "... ... .. .." },
  { name: "United Kingdom", iso2: "gb", dial: "44", format: ".... ......" },
  { name: "Venezuela", iso2: "ve", dial: "58" },
  { name: "Vietnam", iso2: "vn", dial: "84" },
  { name: "Kazakhstan", iso2: "kz", dial: "7", format: "... ...-..-..", priority: 0 },
  { name: "United States", iso2: "us", dial: "1", format: "(...) ...-....", priority: 0 },
  {
    name: "Canada",
    iso2: "ca",
    dial: "1",
    format: "(...) ...-....",
    priority: 1,
    areaCodes: [
      "204",
      "226",
      "236",
      "249",
      "250",
      "289",
      "306",
      "343",
      "365",
      "387",
      "403",
      "416",
      "418",
      "431",
      "437",
      "438",
      "450",
      "506",
      "514",
      "519",
      "548",
      "579",
      "581",
      "587",
      "604",
      "613",
      "639",
      "647",
      "672",
      "705",
      "709",
      "742",
      "778",
      "780",
      "782",
      "807",
      "819",
      "825",
      "867",
      "873",
      "902",
      "905",
    ],
  },
  { name: "Russia", iso2: "ru", dial: "7", format: "(...) ...-..-..", priority: 1 },
  {
    name: "Dominican Republic",
    iso2: "do",
    dial: "1",
    format: "(...) ...-....",
    priority: 2,
    areaCodes: ["809", "829", "849"],
  },
  {
    name: "Puerto Rico",
    iso2: "pr",
    dial: "1",
    format: "(...) ...-....",
    priority: 3,
    areaCodes: ["787", "939"],
  },
  {
    name: "Cayman Islands",
    iso2: "ky",
    dial: "1",
    format: "... ... ....",
    priority: 4,
    areaCodes: ["345"],
  },
];
